import { CKButton } from '@clearkit/react';
import Add from '@material-ui/icons/Add';

import Switch from '~/components/SwitchWithLabel';

import styles from './SharedSettings.style';
import Sidebar, {
  SidebarHeader,
  SidebarTitle,
  SidebarTypography,
} from './Sidebar';
import Webhook from './Webhook';

class WebhookSettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      webhooks: props.form.webhooks.slice(0),
    };
  }

  UNSAFE_componentWillReceiveProps({ form }) {
    if (form) {
      this.setState({
        webhooks: form.webhooks.slice(0),
      });
    }
  }

  setWebhooks = (webhooks) => {
    this.setState({ webhooks });
  };

  onToggle = (attr, event) => {
    let form = Object.assign({}, this.props.form);
    form[attr] = event.target.checked;
    this.props.onUpdateForm(form);
  };

  updateWebhooks = () => {
    const { webhooks } = this.state;

    let form = Object.assign({}, this.props.form, {
      webhooks: webhooks,
    });

    this.props.onUpdateForm(form);
  };

  addWebhook = () => {
    let webhooks = this.state.webhooks.slice(0);
    webhooks.push({ url: '', headers: [] });
    this.setState({ webhooks });
  };

  changeWebhook = (index, webhook) => {
    let webhooks = this.state.webhooks.slice(0);
    webhooks.splice(index, 1, webhook);
    this.setState({ webhooks });
  };

  removeWebhook = (index) => {
    let webhooks = this.state.webhooks.slice(0);
    webhooks.splice(index, 1);
    this.setState({ webhooks }, this.updateWebhooks);
  };

  renderWebhook = (webhook, index) => {
    const { form } = this.props;

    return (
      <Webhook
        form={form}
        webhook={webhook}
        key={index}
        onChange={this.changeWebhook.bind(this, index)}
        onRemove={this.removeWebhook.bind(this, index)}
        onUpdate={this.updateWebhooks}
      />
    );
  };

  render() {
    const { classes, form } = this.props;
    const { webhooks } = this.state;

    return (
      <div className={classes.root}>
        <Sidebar>
          <SidebarHeader>
            <SidebarTitle>Webhook settings</SidebarTitle>

            <Switch
              label="Enabled"
              checked={form.webhook_enabled}
              onChange={this.onToggle.bind(this, 'webhook_enabled')}
            />
          </SidebarHeader>

          <SidebarTypography>
            Receive a HTTP webhook POST every time a form is submitted.
          </SidebarTypography>

          <div className={classes.actions}>
            <CKButton
              onClick={this.addWebhook}
              variant="bold"
              variantColor="blue">
              <Add />
            </CKButton>
          </div>

          {webhooks.map(this.renderWebhook.bind(this))}
        </Sidebar>
      </div>
    );
  }
}

WebhookSettings.propTypes = {
  classes: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  onUpdateForm: PropTypes.func.isRequired,
};

export default withStyles(styles)(WebhookSettings);
